
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns7ac90ccb5fad391c2bab95d5b881b530en from './en.yaml'
            i18n.addResourceBundle('en', '7ac90ccb5fad391c2bab95d5b881b530', flattenObject(ns7ac90ccb5fad391c2bab95d5b881b530en), true, true);
        
        export default '7ac90ccb5fad391c2bab95d5b881b530';
    